'use strict';

const config = require('../config/config');

module.exports = {
  hostify: function (medias, NODE_ENV) {
    const setHost = function (media, type) {
      if (
        media
        && media.media_content
        && media.media_content[type]
      ) {
        var path;
        media.media_content[type] = media.media_content[type].replace(config.hostVar, config[NODE_ENV].mediasBimediaHost);
      }
    } 
    // 
    if (
      !config
      || !config[NODE_ENV]
      || !config[NODE_ENV].mediasBimediaHost
    ) return medias;
    // 
    try {
      medias.forEach( media => {
        setHost(media, 'visuel');
        setHost(media, 'message');
      });
      // 
      return medias;
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  deHostify: function (medias, NODE_ENV) {
    const deHost = function (media, type) {
      if (
        media
        && media.media_content
        && media.media_content[type]
      ) {
        media.media_content[type] = media.media_content[type].replace(config[NODE_ENV].mediasBimediaHost, config.hostVar)
      }
    } 
    // 
    if (
      !config
      || !config[NODE_ENV]
      || !config[NODE_ENV].mediasBimediaHost
    ) {
      console.error('no config[' + NODE_ENV + '].mediasBimediaHost');
      return medias;
    }
    // 
    try {
      medias.forEach( media => {
        deHost(media, 'visuel');
        deHost(media, 'message');
      });
      // 
      return medias;
    } catch (err) {
      console.error(err);
      return false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/common/appUtils.js
// module id = 46
// module chunks = 0